module.exports = __webpack_public_path__ + "dff4fa338b828a07edd2a88ddfa8cf33.svg";